// Tabs.tsx
import React, { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PlungerFormTablet from "./AssetStatusForms/Tablet/PlungerFormTablet";
import PlungerFormMobile from "./AssetStatusForms/Mobile/PlungerFormMobile";
import IoConfigFormMobile from "./AssetStatusForms/Mobile/IOConfigFormMobile";
import IoConfigFormTablet from "./AssetStatusForms/Tablet/IOconfigFormTablet";
import AuxIoConfigFormMobile from "./AssetStatusForms/Mobile/AuxIOConfigFormMobile";
import AuxIoConfigFormTablet from "./AssetStatusForms/Tablet/AuxIOConfigFormTablet";
import LoaderOverlay from "../common/Loader/LoaderOverlay";
import EventLogForm from "../AssetDetails/AssetDetailsForm/EventLogForm";
import GenericFormMobile from "./AssetStatusForms/Mobile/GenericFormMobile";
import GenericFormTablet from "./AssetStatusForms/Tablet/GenericFormTablet";
import { Dayjs } from 'dayjs';
import PfcFormMobile from "./AssetStatusForms/Mobile/PfcFormMobile";
import PfcFormTablet from "./AssetStatusForms/Tablet/PfcFormTablet";
import PlungerForm from "../AssetDetails/AssetDetailsForm/PlungerForm";
import SystemFormMobile from "./AssetStatusForms/Mobile/SystemFormMobile";
import SystemFormTablet from "./AssetStatusForms/Tablet/SystemFormTablet";
import CellularConfigForm from "../AssetDetails/AssetDetailsForm/CellularForm";
import FTPForm from "../AssetDetails/AssetDetailsForm/FTPForm";


interface Tab {
    badge: boolean;
    label: string;
    content: React.ReactNode;
    badgeValue?: number | undefined;
    Uri: string
}

type SetPageFunction = React.Dispatch<React.SetStateAction<string>>

type SetFunction = React.Dispatch<React.SetStateAction<boolean>>

interface TabsProps {
    setTabDivHeight: SetPageFunction,
    assetId: string,
    assetName: string,
    isReadOnly: boolean,
    isSetPointLoading: boolean,
    setIsSetPointLoading: SetFunction,
    handleLogout: () => void,
    initialFormState: { [key: string]: FieldState },
    userTimeZone: string,
    isLatestVersion: boolean;
    isValveControlUser: boolean

}

type FieldState = {
    [key: string]: string;
};

interface SectionItem {
    Id: number;
    Value: string;
}

interface DataObject {
    [key: string]: SectionItem[];
}
export interface StatusFormSetting {
    id: number;
    name: string;
    group: string;
    value: string;
    range: string;
    label: string;
    type: string;
    options: [];
    enable: boolean;
    description?: string;
}


const AssetTabsMobile: React.FC<TabsProps> = ({ initialFormState, assetId, setTabDivHeight, assetName, isReadOnly, isValveControlUser, isSetPointLoading, setIsSetPointLoading, handleLogout, userTimeZone, isLatestVersion }) => {

    // Create the setpoints object dynamically
    const setpoints: { [key: string]: StatusFormSetting[] } = {};

    Object.keys(initialFormState).forEach(key => {
        setpoints[key] = [];
    });

    // Create the Setpoints interface dynamically
    type Setpoints = {
        [K in keyof typeof initialFormState]: StatusFormSetting[];
    };

    // Helper function to create the label from the key
    const createLabel = (key: string) => {
        switch (key) {
            case 'IOConfig':
                return 'Inputs';
            case 'AuxIOConfig':
                return 'Aux Inputs';
            default:
                return key;
        }
    };

    // Helper function to create the content
    const createContent = (key: string) => <div>Content for {key} goes here</div>;

    // Create the assetStatusTabs array dynamically
    const assetStatusTabs = Object.keys(initialFormState).map(key => ({
        label: createLabel(key),
        content: createContent(key),
        badge: false,
        Uri: key,
        badgeValue: ""
    }));

    assetStatusTabs.push({ label: "Event logs", content: createContent("Event logs"), badge: false, Uri: "Event logs", badgeValue: "" })

    const [activeTab, setActiveTab] = useState("Plunger");
    const [formState, setFormState] = useState(initialFormState);
    const [loading, setLoading] = useState(true);
    const baseUrl = process.env.REACT_APP_SERVER_ENDPOINT;
    const [assetStatusFormConfiguration, setAssetStatusFormConfiguration] = useState<Setpoints>();
    const [changedFields, setChangedFields] = useState<{ [formName: string]: Set<string> }>({});
    const [isFormStateReady, setIsFormStateReady] = useState(true);
    const [isToggle, setIsToggle] = useState(false)
    const [addedRows, setAddedRows] = useState<any[]>([]);
    const [editedComments, setEditedComments] = useState<Record<string, { comment: string; change: string }>>({});
    const [eventData, setEventData] = useState([])
    const [selectedRange, setSelectedRange] = useState<{ start: Dayjs | null; end: Dayjs | null }>({ start: null, end: null });
    const [selectedOption, setSelectedOption] = useState("24");
    const [isClickApply, setClickApply] = useState(false);
    const [showPfc, setShowPfc] = useState(false)
    const [showPagl, setShowPagl] = useState(false)
    const [showEventDataMessage, setShowEventDatatMessage] = useState(false)
    const [isRefreshedClick, setIsRefreshedClick] = useState(false)
    const [fileFTPData, setFTPData] = useState([])
    const [showFTPDataMessage, setShowFTPDatatMessage] = useState(false)
    const [hasErrors, setHasErrors] = useState(false);



    const queryParams = {
        // Add your query parameters here
        assetId: assetId,
        userTimeZone,
        flag: selectedOption,
        startDate: selectedRange?.start?.format('MM/DD/YYYY') ?? null, // “06/01/2025”
        endDate: selectedRange?.end?.format('MM/DD/YYYY') ?? null, // “06/18/2025”
    };

    const queryParamsActiveTab = {
        // Add your query parameters here
        assetId: assetId,
        type: activeTab,
        userTimeZone,

    };
    // Convert the query parameters to a string
    const queryStringActiveTab = new URLSearchParams(queryParamsActiveTab).toString();
    const getApiUrlForActiveTab = `${baseUrl}/SetPointsAggregation/GetSetPointsAggregatedData?${queryStringActiveTab}`;
    const getApiUrlFTP = `${baseUrl}/Coredump/GetFiles/${assetId}`;
    const [isMobile, setIsMobile] = useState(window.innerWidth < 620); // Assuming width less than 768px is considered mobile

    useEffect(() => {
        let timeoutId;

        const handleResize = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                setIsMobile(window.innerWidth < 620); // Update state based on window width
            }, 100); // Adjust the debounce interval as needed
        };
        handleResize(); // Initial call to set initial state
        window.addEventListener('resize', handleResize); // Add event listener for window resize

        return () => {
            window.removeEventListener('resize', handleResize); // Remove event listener on component unmount
        };
    }, [window.innerWidth]); // Empty dependency array to run effect only once

    // Convert the query parameters to a string
    const queryString = new URLSearchParams(queryParams).toString();

    const getApiUrl = `${baseUrl}/SetPointsAggregation/GetSetPointsAggregatedData?${queryString}`;
    const postApiUrl = `${baseUrl}/SetPointsAggregation/AddSetPointsDataByAssetId`;
    const getApiUrlForEvents = `${baseUrl}/EventLog/GetAllEventLog?${queryString}`;
    const postApiUrlForEvents = `${baseUrl}/EventLog/UpdateEventLog`;

    const transformedConfiguration: { [key: string]: { Id: number; Value: string }[] } = {};

    for (const [key, value] of Object.entries(assetStatusFormConfiguration || [])) {
        transformedConfiguration[key] = value?.map((obj: { id: any; value: any; }) => ({
            "Id": obj.id,
            "Value": obj.value
        }));
    }
    function setActiveTabLatest(StatusFormSetting) {
        // Define your tab categories
        const tabCategories = Object.keys(initialFormState);

        // Find the first available tab category in StatusFormSetting
        const activeTab = tabCategories.find(category => StatusFormSetting[category]);

        return activeTab || null; // Return the active tab or null if none found
    }

    // Function to display toast message
    const sucessShowToast = () => {
        toast.success('Device command executed succesfully!', {
            position: "top-right", // Corrected
            autoClose: 3000,
            style: {
                color: "white", // Text color
                background: "green", // Background color for success messages
            }
        });
    }

    // Function to display toast message
    const errorShowToast = () => {
        toast.error('Device command failed!', {
            position: "top-right", // Corrected
            autoClose: 3000,
            style: {
                color: "red", // Set your desired text color for error messages
                background: "#f8d7da", // Set your desired background color for error messages
            }
        });
    }

    // Function to display toast message
    const eventsSucessShowToast = () => {
        toast.success('Event Logs command executed succesfully!', {
            position: "top-right", // Corrected
            autoClose: 3000,
            style: {
                color: "white", // Text color
                background: "green", // Background color for success messages
            }
        });
    }

    // Function to display toast message
    const eventErrorShowToast = () => {
        toast.error('Event Logs added/updated command failed!', {
            position: "top-right", // Corrected
            autoClose: 3000,
            style: {
                color: "red", // Set your desired text color for error messages
                background: "#f8d7da", // Set your desired background color for error messages
            }
        });
    }
    // Check if Plunger configuration is available
    const isPlungerAvailable = assetStatusFormConfiguration && assetStatusFormConfiguration?.Plunger?.length > 0;

    // Check if Well configuration is available
    const isWellAvailable = assetStatusFormConfiguration && assetStatusFormConfiguration?.Well?.length > 0;

    // Check if IOConfig configuration is available
    const isIOConfigAvailable = assetStatusFormConfiguration && assetStatusFormConfiguration?.IOConfig?.length > 0;

    // Check if System configuration is available
    const isSystemAvailable = assetStatusFormConfiguration && assetStatusFormConfiguration?.System?.length > 0;

    // Check if Network configuration is available
    const isNetworkAvailable = assetStatusFormConfiguration && assetStatusFormConfiguration?.Network?.length > 0;

    // Check if Test configuration is available
    const isTestAvailable = assetStatusFormConfiguration && assetStatusFormConfiguration?.Test?.length > 0;

    // Check if Test configuration is available
    const isAuxIOConfigAvailable = assetStatusFormConfiguration && assetStatusFormConfiguration?.AuxIOConfig?.length > 0;

    // Filter tabs based on available configurations
    const finalTabs = assetStatusTabs.filter(tab => {

        const isIoConfig = isIOConfigAvailable && tab.Uri === "IOConfig";
        const isAuxIoConfig = isAuxIOConfigAvailable && tab.Uri === "AuxIOConfig";
        if (isIoConfig || isAuxIoConfig) {
            return true;
        }
        else {
            switch (tab.label) {
                case "Plunger":
                    return isPlungerAvailable;
                case "Well":
                    return isWellAvailable;
                case "System":
                    return isSystemAvailable;
                case "Network":
                    return isNetworkAvailable;
                case "Test":
                    return isTestAvailable;
                default:
                    return false;
            }
        }
    });

    const fetchData = async () => {
        const headers = {
            'Authorization': `Bearer ${localStorage.getItem("jwtAccessToken")}`,
            'Content-Type': 'application/json' // Adjust content type if needed
        }
        try {
            const response = await fetch(getApiUrl, { headers });

            if (response.status === 401) {
                handleLogout()
            }

            if (!response.ok || response.status !== 200) {
                setAssetStatusFormConfiguration({})
                setFormState({})
            }
            const data = await response.json();

            if (data) {
                setFormState({})
                setIsToggle(!isToggle)
                const initialFormState = {};

                // Dynamically create the fieldKeys array from the properties of initialFormState
                const fieldKeys = Object.keys(data?.setpoints);

                // Loop through each field key and initialize its state based on data availability
                fieldKeys.forEach((key) => {
                    const initialState = {};
                    // Check if data for the current key exists
                    if (data?.setpoints[key]) {
                        // Iterate over the settings array for the current key
                        data.setpoints[key].forEach((setting) => {
                            initialState[setting.name] = setting.value;
                        });
                    }
                    // Set the initial state for the current key
                    initialFormState[key] = initialState;
                });

                // Set the form state with all dynamic initial states
                setAssetStatusFormConfiguration(data?.setpoints);
                setFormState({ ...initialFormState });
                setIsFormStateReady(false)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setIsFormStateReady(false)
        }
        finally {
            setLoading(false); // Set loading to false whether the fetch was successful or not
            setIsFormStateReady(false)
        }
    };

    const fetchEventData = async () => {
        const headers = {
            'Authorization': `Bearer ${localStorage.getItem("jwtAccessToken")}`,
            'Content-Type': 'application/json' // Adjust content type if needed
        }
        try {
            if (selectedOption === "Custom" && isClickApply === false) return

            const response = await fetch(getApiUrlForEvents, { headers });

            if (response.status === 401) {
                handleLogout()
            }

            if (!response.ok || response.status !== 200) {
                setEventData([])
            }
            const data = await response.json();

            if (data?.length === 0) {
                setShowEventDatatMessage(true)
            }

            if (data) {
                setIsToggle(!isToggle)
                setAddedRows([])
                setEditedComments({})
                setEventData(data)
                setIsFormStateReady(false)
                setClickApply(false)
            }
        } catch (error) {
            setIsFormStateReady(false)
        }
        finally {
            setIsFormStateReady(false)
            setLoading(false); // Set loading to false whether the fetch was successful or not      
        }
    };

    const fetchFTPData = async () => {
        const headers = {
            'Authorization': `Bearer ${localStorage.getItem("jwtAccessToken")}`,
            'Content-Type': 'application/json' // Adjust content type if needed
        }
        try {
            const response = await fetch(getApiUrlFTP, { headers });

            if (response.status === 401) {
                handleLogout()
            }

            if (response.status === 404) {
                setShowFTPDatatMessage(true)
            }

            if (!response.ok || response.status !== 200) {
                setFTPData([])
            }

            const data = await response.json();

            if (data) {
                setFTPData(data)
            }
        } catch (error) {
        }
        finally {
            setLoading(false); // Set loading to false whether the fetch was successful or not      
        }
    };


    useEffect(() => {
        setLoading(true);
        setIsFormStateReady(true)
        setFormState({})
        onHandleRefresh()
    }, [assetId]);

    useEffect(() => {
        if (assetStatusFormConfiguration) {
            // Get an array of property names
            const propertyNames = Object.keys(assetStatusFormConfiguration);

            // Check if there are any properties
            if (propertyNames.length > 0) {
                // Get the first property name
                const firstPropertyName = propertyNames[0];
                setActiveTabLatest(firstPropertyName)
            }

            const modeItem = assetStatusFormConfiguration?.Outputs?.find(
                (item) => item?.id === 121
            );

            const plungerModeItem = assetStatusFormConfiguration?.Plunger?.find(
                (item) => item?.id === 10
            );

            const modeValue = modeItem?.value;
            const plungerModeValue = plungerModeItem?.value;
            if (modeValue === "6" || modeValue === "7") {
                setShowPfc(true)
            }
            else {
                setShowPfc(false)
            }
            if (plungerModeValue === "4") {
                setShowPagl(true)
            }
            else {
                setShowPagl(false)
            }

        }
    }, [assetStatusFormConfiguration])

    useEffect(() => {
        if (activeTab === "Event logs") {
            fetchEventData()
        }
        if (activeTab === "FTP") {
            fetchFTPData()
        }
        else {
            if (activeTab !== "Event logs") {
                setSelectedOption("24")
            }
            fetchData();
            // fetch event data
            setChangedFields({})
        }
    }, [activeTab, selectedOption, isClickApply]);

    const onHandleRefresh = async () => {
        setIsSetPointLoading(true)
        setFormState({})
        await fetchData();
        if (activeTab === "Event logs") {
            await fetchEventData();
        }
        if (activeTab === "FTP") {
            fetchFTPData()
        }
        // Fetch Event Data
        setChangedFields({})
        setIsSetPointLoading(false)
        setIsRefreshedClick(!isRefreshedClick)
    }

    const onClickhandler = (activeTabName: string) => {
        setActiveTab(activeTabName)
    }

    const saveSetpointsData = async (queryParams) => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json', // specify content type as JSON if sending JSON data
                'Authorization': `Bearer ${localStorage.getItem("jwtAccessToken")}`,
                // You may need to include additional headers based on your API requirements
            },
            body: JSON.stringify(queryParams) // convert data to JSON string
        };
        try {
            const response = await fetch(postApiUrl, requestOptions);

            if (response.status === 401) {
                handleLogout()
            }

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            if (data === false) {
                errorShowToast()
                return data;
            }
            else {
                sucessShowToast()
                return true
            }

        } catch (error) {
            console.error('Error fetching data:', error);
            return false
        }
    };

    const saveEventsData = async (queryParams) => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json', // specify content type as JSON if sending JSON data
                'Authorization': `Bearer ${localStorage.getItem("jwtAccessToken")}`,
                // You may need to include additional headers based on your API requirements
            },
            body: JSON.stringify(queryParams) // convert data to JSON string
        };
        try {
            const response = await fetch(postApiUrlForEvents, requestOptions);

            if (response.status === 401) {
                handleLogout()
            }

            if (!response.ok) {
                eventErrorShowToast()
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            if (data === false) {
                eventErrorShowToast()
                return data;
            }
            else {
                eventsSucessShowToast()
                return true
            }

        } catch (error) {
            console.error('Error fetching data:', error);
            return false
        }
    };

    const filterChangedValues = (original: DataObject, updated: DataObject): { Id: number, Value: any }[] => {
        const changedValues: { Id: number, Value: any }[] = [];

        // Iterate over each section in the updated data
        for (const section in updated) {
            if (updated.hasOwnProperty(section) && original.hasOwnProperty(section)) {
                // Find the corresponding section in the original data
                const originalSection = original[section];
                const updatedSection = updated[section];

                // Merge the sections into a single array
                const mergedSection = originalSection.concat(updatedSection);

                // Create a map to store items by their ID for quick lookup
                const itemMap = new Map<number, { Id: number, Value: any }>();

                // Add original section items to the map
                originalSection.forEach(item => itemMap.set(item.Id, item));

                // Filter the merged array to get only the changed values
                const changedSectionValues = mergedSection.reduce((acc, item) => {
                    const originalItem = itemMap.get(item.Id);
                    if (originalItem && originalItem.Value !== item.Value) {
                        acc.push(item);
                    }
                    return acc;
                }, []);

                // Add the changed values to the result
                changedValues.push(...changedSectionValues);
            }
        }

        return changedValues;
    }

    const onSaveFormChange = async (e: any) => {
        e.preventDefault();
        setIsSetPointLoading(true)

        if (activeTab === "Event logs") {
            if (addedRows.length > 0 || Object.keys(editedComments).length > 0) {

                const postBody = {
                    AddedEvents: addedRows.map(row => ({
                        eventId: row.eventId,
                        date: row.date,
                        type: row.type,
                        source: row.source,
                        change: row.change,
                        comment: row.comment
                    })),

                    UpdatedEvents: Object.entries(editedComments).map(([eventId, commentData]) => ({
                        EventId: eventId,
                        comment: commentData.comment,
                        change: commentData.change
                    })),
                    assetId,
                    userTimeZone
                };

                const response = await saveEventsData(postBody)

                if (response === false) {
                    setIsSetPointLoading(false)
                }
                else {
                    setTimeout(async () => {
                        await fetchEventData()
                        setIsSetPointLoading(false)
                    }, 3000)
                }
            }
            else {
                alert("Register Value Not Changed")
                setIsSetPointLoading(false)
            }
        }
        else {

            // Initialize the final object
            const finalObject: { [key: string]: { Id: number; Value: string }[] } = {};

            // Iterate over each section in the formState object
            for (const sectionName in formState) {
                // Ensure the property exists in both formState and assetStatusFormConfiguration
                if (formState.hasOwnProperty(sectionName) && assetStatusFormConfiguration && assetStatusFormConfiguration.hasOwnProperty(sectionName)) {
                    // Retrieve the settings for the current section from formState
                    const sectionSettings = formState[sectionName as keyof typeof formState];

                    // Find the corresponding section in assetStatusFormConfiguration
                    const sectionConfig = assetStatusFormConfiguration[sectionName as keyof typeof assetStatusFormConfiguration];

                    // Initialize an array to store ID and Value pairs for the current section
                    const sectionArray: { Id: number; Value: string }[] = [];

                    // Iterate over each setting in the current section
                    for (const setting of sectionConfig) {
                        // Retrieve the setting value from formState based on the setting name
                        const settingValue = sectionSettings[setting.name];

                        // Add ID and Value to the sectionArray
                        sectionArray.push({
                            Id: setting.id,
                            Value: settingValue !== undefined ? settingValue : '' // Set default value if setting is undefined
                        });
                    }

                    // Add the sectionArray to the finalObject under the section name
                    finalObject[sectionName] = sectionArray;
                }
            }
            const registers = filterChangedValues(transformedConfiguration, finalObject)

            if (registers.length > 0) {
                const postBody = { registers, assetId, assetName }

                var response = await saveSetpointsData(postBody)

                if (response === false) {
                    setIsSetPointLoading(false)
                }
                else {
                    setIsSetPointLoading(false)
                    setChangedFields({})
                    setTimeout(async () => {
                        await fetchData();
                    }, 2000);
                }

            }
            else {
                alert("Register Value Not Changed")
                setIsSetPointLoading(false)
            }
        }

    }


    if (isFormStateReady) {
        return <LoaderOverlay />; // Show a loading indicator while formState is being prepared
    }



    return (
        <div className="flex flex-col w-full">
            {/* Tab Labels */}
            <div className="flex mb-1 bg-darkcolor-650 mb-5 tab-container overflow-x-auto">
                {assetStatusTabs.filter(
                    (tab) =>
                        (tab.label !== "PFC" || showPfc) &&
                        (tab.label !== "PAGL" || showPagl))
                    .map((tab, index) => (
                        <div
                            key={index}
                            className={`${activeTab === tab.label
                                ? "border-b-[2px] border-secondary-500 text-primary-400 font-semibold"
                                : "hover:bg-darkcolor-600 hover:border-none cursor-pointer"
                                } px-4 focus:outline-none flex justify-center items-center gap-[8px] py-2`}
                            onClick={() => onClickhandler(tab.label)}
                        >
                            <div className="flex items-center">
                                <span className="text-[16px]">{tab.label}</span>
                                {tab.badge && (
                                    <span className="ml-2 py-0 px-[4px] rounded-[2px] bg-secondary-500 text-white text-[12px]">
                                        {tab.badgeValue}
                                    </span>
                                )}
                            </div>
                        </div>
                    ))}
                <button
                    type="button"
                    className={`btn btn-primary ${isSetPointLoading ? 'disabled-button' : ''}`}
                    style={{ marginTop: "20px", height: "50px", marginLeft: "auto", color: "white", marginBottom: "15px", backgroundColor: "var(--Primary-Indigo-700, #005F7C)" }}
                    onClick={onHandleRefresh}
                    disabled={isSetPointLoading}
                >
                    Refresh
                </button>
                {(!isReadOnly && !isValveControlUser) && (
                    <button
                        type="button"
                        className={`btn btn-primary ${isSetPointLoading || hasErrors ? 'disabled-button' : ''}`}
                        style={{
                            marginTop: "20px",
                            height: "50px", marginLeft: "5px", marginBottom: "15px", color: "white", backgroundColor: "var(--Primary-Indigo-700, #005F7C)"
                        }}
                        onClick={(e: any) => onSaveFormChange(e)}
                        disabled={isSetPointLoading || hasErrors}
                    >
                        Save
                    </button>
                )}
            </div>
            <div>
                {(() => {
                    const formData = assetStatusFormConfiguration?.[activeTab];
                    const formStateContainsData = formState && formState.hasOwnProperty(activeTab) && formData;
                    switch (activeTab) {
                        case "Inputs":
                            return assetStatusFormConfiguration?.IOConfig ? (isMobile ? <IoConfigFormMobile formState={formState} setFormState={setFormState} setTabDivHeight={setTabDivHeight} IoConfigFormData={assetStatusFormConfiguration?.IOConfig} changedFields={changedFields} setChangedFields={setChangedFields} formNames="IOConfig" isToggle={isToggle} /> : <IoConfigFormTablet formState={formState} setFormState={setFormState} setTabDivHeight={setTabDivHeight} IoConfigFormData={assetStatusFormConfiguration?.IOConfig} changedFields={changedFields} setChangedFields={setChangedFields} formNames="IOConfig" isToggle={isToggle} />) : <></>;
                        case "Aux Inputs":
                            return assetStatusFormConfiguration?.AuxIOConfig ? (isMobile ? <AuxIoConfigFormMobile formState={formState} setFormState={setFormState} setTabDivHeight={setTabDivHeight} AuxIoConfigFormData={assetStatusFormConfiguration?.AuxIOConfig} changedFields={changedFields} setChangedFields={setChangedFields} formNames="AuxIOConfig" isToggle={isToggle} /> : <AuxIoConfigFormTablet formState={formState} setFormState={setFormState} setTabDivHeight={setTabDivHeight} IoConfigFormData={assetStatusFormConfiguration?.AuxIOConfig} changedFields={changedFields} setChangedFields={setChangedFields} formNames="AuxIOConfig" isToggle={isToggle} />) : <></>;
                        case "Event logs":
                            return <EventLogForm setTabDivHeight={setTabDivHeight} eventData={eventData} addedRows={addedRows} setAddedRows={setAddedRows} editedComments={editedComments} setEditedComments={setEditedComments} isToggle={isToggle} selectedOption={selectedOption} setSelectedOption={setSelectedOption} selectedRange={selectedRange} setSelectedRange={setSelectedRange} setClickApply={setClickApply} showEventDataMessage={showEventDataMessage} />
                        case "Plunger": {
                            // Get tubing length object from Well config (id 7)
                            const tubingLengthObj = assetStatusFormConfiguration?.Well?.find(f => f.id === 7);
                            const wellsFormData = tubingLengthObj ? [tubingLengthObj] : [];
                            return !isFormStateReady ? (isMobile ?
                                <PlungerForm
                                    formState={formState}
                                    setFormState={setFormState}
                                    setTabDivHeight={setTabDivHeight}
                                    PlungerFormData={formData}
                                    WellsFormData={wellsFormData}
                                    changedFields={changedFields}
                                    setChangedFields={setChangedFields}
                                    formNames={activeTab}
                                    isToggle={isToggle}
                                    isSetPointLoading={isSetPointLoading}
                                    isLatestVersion={isLatestVersion}
                                    setHasErrors={setHasErrors}
                                /> :
                                <PlungerForm
                                    formState={formState}
                                    setFormState={setFormState}
                                    setTabDivHeight={setTabDivHeight}
                                    PlungerFormData={formData}
                                    WellsFormData={wellsFormData}
                                    changedFields={changedFields}
                                    setChangedFields={setChangedFields}
                                    formNames={activeTab}
                                    isToggle={isToggle}
                                    isSetPointLoading={isSetPointLoading}
                                    isLatestVersion={isLatestVersion}
                                    setHasErrors={setHasErrors}
                                />
                            ) : <></>;
                        }
                        case "System": {
                            return assetStatusFormConfiguration?.System ? (isMobile ?
                                <SystemFormMobile
                                    formState={formState}
                                    setFormState={setFormState}
                                    setTabDivHeight={setTabDivHeight}
                                    SystemFormData={assetStatusFormConfiguration?.System}
                                    changedFields={changedFields}
                                    setChangedFields={setChangedFields}
                                    formNames="System"
                                    isToggle={isToggle}
                                    isSetPointLoading={isSetPointLoading}
                                /> :
                                <SystemFormTablet
                                    formState={formState}
                                    setFormState={setFormState}
                                    setTabDivHeight={setTabDivHeight}
                                    SystemFormData={assetStatusFormConfiguration?.System}
                                    changedFields={changedFields}
                                    setChangedFields={setChangedFields}
                                    formNames="System"
                                    isToggle={isToggle}
                                    isSetPointLoading={isSetPointLoading}
                                />
                            ) : <></>;
                        }
                        case "Cellular": {
                            return assetStatusFormConfiguration?.Cellular ? (
                                <CellularConfigForm
                                    formState={formState}
                                    setFormState={setFormState}
                                    setTabDivHeight={setTabDivHeight}
                                    CellularConfigFormData={assetStatusFormConfiguration?.Cellular}
                                    changedFields={changedFields}
                                    setChangedFields={setChangedFields}
                                    formNames="Cellular"
                                    isToggle={isToggle}
                                    assetId={assetId}
                                    userTimeZone={userTimeZone}
                                    handleLogout={handleLogout}
                                    isRefreshedClick={isRefreshedClick}
                                />
                            ) : <></>;
                        }
                        case "FTP":
                            return fileFTPData && fileFTPData.length > 0 ? ( 
                        <FTPForm assetId={assetId} setTabDivHeight={setTabDivHeight} ftpData={fileFTPData} addedRows={addedRows} setAddedRows={setAddedRows} isToggle={isToggle} selectedOption={selectedOption} setSelectedOption={setSelectedOption} selectedRange={selectedRange} setSelectedRange={setSelectedRange} setClickApply={setClickApply} showFTPDataMessage={showFTPDataMessage} onHandleRefresh={onHandleRefresh}/>
                            ) : (
                                <div style={{ color: "white", textAlign: "center", padding: "2rem" }}>No FTP files found.</div>
                            );
                        case "PFC":
                            return assetStatusFormConfiguration?.PFC ? (isMobile ?
                                <PfcFormMobile
                                    formState={formState}
                                    setFormState={setFormState}
                                    setTabDivHeight={setTabDivHeight}
                                    PfcFormData={assetStatusFormConfiguration?.PFC}
                                    changedFields={changedFields}
                                    setChangedFields={setChangedFields}
                                    formNames="PFC"
                                    isToggle={isToggle}
                                /> :
                                <PfcFormTablet
                                    formState={formState}
                                    setFormState={setFormState}
                                    setTabDivHeight={setTabDivHeight}
                                    PFCFormData={assetStatusFormConfiguration?.PFC}
                                    changedFields={changedFields}
                                    setChangedFields={setChangedFields}
                                    formNames="PFC"
                                    isToggle={isToggle}
                                />
                            ) : <></>;
                        default:
                            return !isFormStateReady ? (isMobile ?
                                <GenericFormMobile
                                    formState={formState}
                                    setFormState={setFormState}
                                    setTabDivHeight={setTabDivHeight}
                                    GenericFormData={formData}
                                    changedFields={changedFields}
                                    setChangedFields={setChangedFields}
                                    formNames={activeTab}
                                    isToggle={isToggle}
                                /> :
                                <GenericFormTablet
                                    formState={formState}
                                    setFormState={setFormState}
                                    setTabDivHeight={setTabDivHeight}
                                    GenericFormData={formData}
                                    changedFields={changedFields}
                                    setChangedFields={setChangedFields}
                                    formNames={activeTab}
                                    isToggle={isToggle}
                                />
                            ) : <></>;
                    }
                })()}
            </div>
        </div>
    );
};

export default AssetTabsMobile;
